// Svensk formatering + tillgänglig status-triad (färg + text + ikon/symbol)
import { CheckCircle2, AlertTriangle, AlertOctagon, Feather, Activity, Weight } from "lucide-react";

const dateFmt = new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Stockholm", dateStyle: "medium" });
const dateLong = new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Stockholm", weekday: "long", day: "numeric", month: "long" });
const timeFmt = new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Stockholm", hour: "2-digit", minute: "2-digit" });
const dtFmt = new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Stockholm", dateStyle: "short", timeStyle: "short" });

export const fDate = (v) => (v ? dateFmt.format(new Date(v)) : "—");
export const fDateLong = (v) => (v ? dateLong.format(new Date(v)) : "—");
export const fTime = (v) => (v ? timeFmt.format(new Date(v)) : "—");
export const fDateTime = (v) => (v ? dtFmt.format(new Date(v)) : "—");
export const fPct = (v) => `${(v ?? 0).toLocaleString("sv-SE", { maximumFractionDigits: 1 })} %`;

// Belastnings-/rotationsnivå
export const STATUS = {
  gron: { label: "Normal", full: "Grön – under gränsvärdet", icon: CheckCircle2, symbol: "●",
    text: "text-emerald-700", bg: "bg-emerald-50", border: "border-emerald-300", dot: "bg-emerald-600" },
  gul: { label: "Nära gräns", full: "Gul – nära gränsvärdet", icon: AlertTriangle, symbol: "▲",
    text: "text-amber-700", bg: "bg-amber-50", border: "border-amber-300", dot: "bg-amber-500" },
  rod: { label: "Gräns överskriden", full: "Röd – gränsvärdet överskridet", icon: AlertOctagon, symbol: "■",
    text: "text-red-700", bg: "bg-red-50", border: "border-red-300", dot: "bg-red-600" },
};
export const statusMeta = (lvl) => STATUS[lvl] || STATUS.gron;

// Belastningsklass
export const LOAD = {
  latt: { label: "Lätt", icon: Feather, text: "text-sky-700", bg: "bg-sky-50", border: "border-sky-300" },
  medel: { label: "Medel", icon: Activity, text: "text-amber-700", bg: "bg-amber-50", border: "border-amber-300" },
  tung: { label: "Tung", icon: Weight, text: "text-orange-800", bg: "bg-orange-50", border: "border-orange-300" },
};
export const loadMeta = (c) => LOAD[c] || LOAD.medel;

export const LEAVE_STATUS = {
  utkast: "Utkast", inskickad: "Inskickad", "godkänd": "Godkänd",
  avslagen: "Avslagen", "återkallad": "Återkallad",
};
